import apiInstance from "./apiInstance";
import { nanoid } from "@reduxjs/toolkit";
import axios from "axios";

const saveFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file", file, config);
};

const uploadFile = (params) => {
  const { baslik, aciklama, dosya } = params;
  let formData = new FormData();
  formData.append("baslik", baslik);
  formData.append("aciklama", aciklama);
  formData.append("dosya", dosya);
  return apiInstance.post("file", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

const uploadFileFromString = (params) => {
  const { baslik, aciklama, string } = params;

  const formData = new FormData();
  formData.append("baslik", baslik);
  formData.append("aciklama", aciklama);
  formData.append("dosya", new Blob([string]), nanoid() + ".html");

  return apiInstance({
    method: "post",
    url: "file",
    data: formData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

const getFileDetails = (sha1) => {
  return apiInstance.get(`file/presignedURL/${sha1}`);
};

const getFileContent = (params) => {
  const { sha1, fileName } = params;
  return apiInstance.get(`file/${sha1}/${fileName}`);
};

const getFileMetadata = (sha1) => {
  return apiInstance.get(`file/metadata/${sha1}`);
};

const getUnauthFileMetadata = (sha1) => {
  return apiInstance.get(`school-activity-application/metadata/${sha1}`);
};

const getUnauthFileDetails = (sha1) => {
  return apiInstance.get(`school-activity-application/presignedURL/${sha1}`);
};

const deleteFile = (sha1) => {
  return apiInstance.delete(`file/${sha1}`);
};

const multiDeleteFile = (sha1Arr) => {
  return apiInstance.post("file/multiDelete", sha1Arr);
};

const getVideoDetails = (url) => {
  return axios.get(`https://vimeo.com/api/oembed.json?url=${url}`);
};

const getFileContentDetail = (sha1) => {
  return apiInstance.get(`file/content/${sha1}`);
};

const getQuestionFileContentDetail = (sha1) => {
  return apiInstance.get(`file/content/question/${sha1}`);
};

const getQuestionPresignedUrl = (sha1) => {
  return apiInstance.get(`/file/presignedURL/question/${sha1}`);
};

const getQuestionPresignedUrlV2 = (sha1) => {
  return apiInstance.get(`/file/presignedURL/question/${sha1}?version=v2`);
};

const uploadMultiFile = (files) => {
  return apiInstance.post("file/multifileupload", files);
};

const saveAsFile = (value) => {
  return apiInstance.post("file", value);
};

const saveInstantMessageFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/instantMessage", file, config);
};

const deleteInstantMessageFile = (sha1) => {
  return apiInstance.delete(`file/instantMessage/${sha1}`);
};

const getInstantMessageFileMetadata = (sha1) => {
  return apiInstance.get(`file/instantMessage/metadata/${sha1}`);
};

const getInstantMessageFileDetails = (sha1) => {
  return apiInstance.get(`file/instantMessage/presignedURL/${sha1}`);
};

const saveFileShareFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/fileShare", file, config);
};

const deleteFileShareFile = (sha1) => {
  return apiInstance.delete(`file/fileShare/${sha1}`);
};

const getFileShareFileMetadata = (sha1) => {
  return apiInstance.get(`file/fileShare/metadata/${sha1}`);
};

const getFileShareFileDetails = (sha1) => {
  return apiInstance.get(`file/fileShare/presignedURL/${sha1}`);
};

const savePdfQuestionFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/pdfQuestion", file, config);
};

const deletePdfQuestionFile = (sha1) => {
  return apiInstance.delete(`file/pdfQuestion/${sha1}`);
};

const getPdfQuestionFileMetadata = (sha1) => {
  return apiInstance.get(`file/pdfQuestion/metadata/${sha1}`);
};

const getPdfQuestionFileDetails = (sha1) => {
  return apiInstance.get(`file/pdfQuestion/presignedURL/${sha1}`);
};

const getPdfQuestionMultipleFileDetails = (sha1List) => {
  return apiInstance.post(`file/pdfQuestion/presignedURL/multiple`, sha1List);
};

const savePdfProjectFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/pdfProject", file, config);
};

const savePersonalBookFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/personalBook", file, config);
};

const getPersonalBookFileDetails = (sha1) => {
  return apiInstance.get(`file/personalBook/presignedURL/${sha1}`);
};

const getPersonalBookPDFFileList = (bookId) => {
  return apiInstance.get(`file/personalBook/pdf/${bookId}`);
};

const getPersonalBookPDFFileURL = (path) => {
  return apiInstance.get(`file/personalBook/pdf/url?path=${path}`);
};

const getPersonalBookPDFSummaryFileURL = (path) => {
  return apiInstance.get(`file/personalBook/pdf/summary/url?path=${path}`);
};

const deletePersonalBookFile = (sha1) => {
  return apiInstance.delete(`file/personalBook/${sha1}`);
};

const saveQuestionFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/question", file, config);
};

const saveQuestionFileV2 = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/question?version=v2", file, config);
};

const getQuestionBooksFileDetails = (sha1) => {
  return apiInstance.get(`file/questionBooks/presignedURL/${sha1}`);
};

const deleteQuestionBooksFile = (sha1) => {
  return apiInstance.delete(`file/questionBooks/${sha1}`);
};

const saveQuestionBookFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/questionBooks", file, config);
};

const saveExamSessionApprovalFile = (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return apiInstance.post("file/fileUpload/examSessionApproval", file, config);
};

const getExamSessionApprovalFileURL = (sha1) => {
  return apiInstance.get(`file/examSessionApproval/presignedURL/${sha1}`);
};
export {
  saveFile,
  uploadFile,
  getFileDetails,
  deleteFile,
  multiDeleteFile,
  getFileMetadata,
  getVideoDetails,
  getFileContent,
  uploadFileFromString,
  getFileContentDetail,
  uploadMultiFile,
  saveAsFile,
  getQuestionFileContentDetail,
  getQuestionPresignedUrl,
  getQuestionPresignedUrlV2,
  saveInstantMessageFile,
  deleteInstantMessageFile,
  getInstantMessageFileMetadata,
  getInstantMessageFileDetails,
  saveFileShareFile,
  deleteFileShareFile,
  getFileShareFileMetadata,
  getFileShareFileDetails,
  savePdfQuestionFile,
  deletePdfQuestionFile,
  getPdfQuestionFileMetadata,
  getPdfQuestionFileDetails,
  getPdfQuestionMultipleFileDetails,
  savePdfProjectFile,
  savePersonalBookFile,
  getPersonalBookFileDetails,
  getPersonalBookPDFFileList,
  getPersonalBookPDFFileURL,
  deletePersonalBookFile,
  saveQuestionFile,
  saveQuestionFileV2,
  getQuestionBooksFileDetails,
  saveQuestionBookFile,
  deleteQuestionBooksFile,
  saveExamSessionApprovalFile,
  getExamSessionApprovalFileURL,
  getPersonalBookPDFSummaryFileURL,
  getUnauthFileMetadata,
  getUnauthFileDetails
};
